export const APPLICATION_REDUCER_STATE_ID = 'application';
